
import TransactionList from '@/components/TransactionList.vue'
import { useApi } from '@/lib/api'
import { defineComponent, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import ContractBox from './ContractBox.vue'
import InputCheck from './common/InputCheck.vue'
import { useStore } from 'vuex'
import { downloadStream, useAppViewedList } from '@/lib/common'

export default defineComponent({
  components: { TransactionList, ContractBox, InputCheck },
  setup() {
    const { setRecord } = useAppViewedList()
    const _api = useApi()
    const _store = useStore()
    const _route = useRoute()
    const data = ref({ contract: {}, transactionList: [] })
    const showAll = ref(false)

    const getData = async () => {
      const res = await _api.get<any>('contract?id=' + _route.params.id)
      if (res.status === 200) {
        const r = admin.value ? 'adminContractList' : 'contractList'
        setRecord(r + _route.params.id)
        data.value = res.data
      }
    }

    const admin = computed(() => _route.fullPath.indexOf('/administracija') === 0)

    getData()

    const transList = computed(() => (showAll.value ? data.value.transactionList : data.value.transactionList.filter((x: any) => x.cancelled !== true && x.idPrev === null)))

    const toXls = async () => {
      _store.commit('appLoading', true)
      try {
        const res = await _api.axios.post('adminTransactionList?id=' + _route.params.id, null, { responseType: 'blob' })
        if (res.status === 200) {
          downloadStream(res.data, 'Seznam_transakcij.xlsx')
        }
      } finally {
        _store.commit('appLoading', false)
      }
    }

    return { data, showAll, transList, admin, toXls }
  }
})
